export default function autoComplete() {  
    $("#cep").focusout(function(){ 
        $.ajax({ 
            url: 'https://viacep.com.br/ws/'+$(this).val()+'/json', 
            dataType: 'json', 
            success: function(resposta){ 
                $("#logradouro").val(resposta.logradouro);
                $("#complemento").val(resposta.complemento);
                $("#localidade").val(resposta.localidade);
                $("#uf").val(resposta.uf);
                $("#bairro").val(resposta.bairro);    
                $("#numero").focus(); 
            }
        });
    }); 
}